// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"node_modules_xlsx_dist_xlsx_mini_min_js":"b99b116527aadad0","node_modules_xlsx_xlsx_mjs":"b68bda789749d202"}[chunkId] + ".js";
};